module.exports = __webpack_public_path__ + "static/media/mira_session.929675de.jpg";